export default __webpack_public_path__ + "static/media/placeholder_business02-es-mobile.84d3f252.png";